import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, mergeProps as _mergeProps, createElementVNode as _createElementVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "fill-height d-flex flex-column",
  style: {"width":"100%"}
}
const _hoisted_2 = { class: "d-flex justify-end mb-6 align-center" }
const _hoisted_3 = { class: "d-flex justify-center" }
const _hoisted_4 = {
  class: "d-flex flex-column align-center",
  style: {"width":"400px"}
}
const _hoisted_5 = {
  class: "d-flex justify-space-between align-start",
  style: {"width":"100%","height":"100px","margin-top":"20px"}
}
const _hoisted_6 = { class: "d-flex justify-space-between" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_select = _resolveComponent("v-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_tooltip, {
        text: _ctx.t('raster.tooltip.reset_bbox'),
        bottom: "",
        "open-delay": 200,
        style: {"z-index":"99999"}
      }, {
        activator: _withCtx(({ props }) => [
          _createVNode(_component_v_btn, _mergeProps(props, {
            variant: "outlined",
            color: "error",
            "data-testid": "control-panel-bbox-delete",
            style: {"padding":"0","min-width":"36px","margin-left":"12px"},
            width: "36px",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.gridStore.resetBbox()))
          }), {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, { color: "error" }, {
                default: _withCtx(() => [...(_cache[13] || (_cache[13] = [
                  _createTextVNode(" mdi-delete-outline ", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 16)
        ]),
        _: 1
      }, 8, ["text"])
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.northString,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.northString) = $event)),
            class: "coord-input",
            "data-testid": "north-input",
            variant: "filled",
            label: _ctx.t('north'),
            suffix: "°",
            rules: [_ctx.isValidNorth],
            onInput: _cache[2] || (_cache[2] = (event) => _ctx.gridStore.changeBboxNorth(event.target.value))
          }, null, 8, ["modelValue", "label", "rules"]),
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.westString,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.westString) = $event)),
              class: "coord-input",
              "data-testid": "west-input",
              variant: "filled",
              label: _ctx.t('west'),
              suffix: "°",
              rules: [_ctx.isValidWest],
              onInput: _cache[4] || (_cache[4] = (event) => _ctx.gridStore.changeBboxWest(event.target.value))
            }, null, 8, ["modelValue", "label", "rules"]),
            _createVNode(_component_v_text_field, {
              modelValue: _ctx.eastString,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.eastString) = $event)),
              class: "coord-input",
              "data-testid": "east-input",
              variant: "filled",
              label: _ctx.t('east'),
              suffix: "°",
              rules: [_ctx.isValidEast],
              onInput: _cache[6] || (_cache[6] = (event) => _ctx.gridStore.changeBboxEast(event.target.value))
            }, null, 8, ["modelValue", "label", "rules"])
          ]),
          _createVNode(_component_v_text_field, {
            modelValue: _ctx.southString,
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.southString) = $event)),
            class: "coord-input",
            "data-testid": "south-input",
            variant: "filled",
            label: _ctx.t('south'),
            suffix: "°",
            rules: [_ctx.isValidSouth],
            onInput: _cache[8] || (_cache[8] = (event) => _ctx.gridStore.changeBboxSouth(event.target.value))
          }, null, 8, ["modelValue", "label", "rules"])
        ])
      ])
    ], 512), [
      [_vShow, _ctx.inputHelpIsActive]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_v_text_field, {
        modelValue: _ctx.textualBboxString,
        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.textualBboxString) = $event)),
        variant: "filled",
        "data-testid": "bbox-text-input",
        "persistent-hint": "",
        class: "mt-4",
        label: _ctx.t('raster.bbox_control.text_field_label'),
        hint: _ctx.t('raster.bbox_control.text_field_hint'),
        rules: [_ctx.isValidBbox],
        onInput: _cache[10] || (_cache[10] = (event) => _ctx.gridStore.changeTextualBbox(event.target.value))
      }, null, 8, ["modelValue", "label", "hint", "rules"])
    ], 512), [
      [_vShow, !_ctx.inputHelpIsActive]
    ]),
    _createVNode(_component_v_spacer),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_checkbox, {
        modelValue: _ctx.inputHelpIsActive,
        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.inputHelpIsActive) = $event)),
        "data-testid": "bbox-input-help",
        label: _ctx.t('raster.input_help_label')
      }, null, 8, ["modelValue", "label"]),
      _createVNode(_component_v_select, {
        modelValue: _ctx.selectedPreset,
        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.selectedPreset) = $event)),
        style: {"max-width":"250px","height":"40px"},
        items: _ctx.bboxPresetChoices,
        "item-title": "label",
        "item-value": "value",
        variant: "outlined",
        density: "compact",
        "hide-details": "",
        "data-testid": "bbox-preset-choices",
        label: _ctx.t('raster.tooltip.template_selection')
      }, null, 8, ["modelValue", "items", "label"])
    ])
  ]))
}